// extracted by mini-css-extract-plugin
export default {"container":"VisionMission_container__h0woB","iconWrapper":"VisionMission_iconWrapper__Fvv-Q","title":"VisionMission_title__Szqaa","text":"VisionMission_text__3Uivt"};